export const HUNDRED_AND_TEN_PERCENT = 1.1;
export const Y_AXIS_TICKS = 5;
export const X_AXIS_PADDING_DAYS = 5;

export interface ChartMargin {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export const DATA_CLASS_NAME = 'chart-data-rows';
export const LINE_CHART_ANIMATION_DURATION = 2000;
export const TOOLTIP_AVERAGE_WIDTH = 210;
export const TOOLTIP_AVERAGE_HEIGHT = 30;
